'use strict';

exports.__esModule = true;
exports.post = post;
exports.remove = remove;

var _apiClient = require('../network/api-client');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _auth = require('../auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var API = {
  VISITOR: '/visitor'

  /**
   * Wrapper for `/visitor` API endpoint
   */

};var visitor = {
  post: post,
  remove: remove
};

exports.default = visitor;

/**
 * Creates a new visitor session
 * @returns {promise} containing the visitor
 */

function post() {
  return _apiClient2.default.post({ route: API.VISITOR }).then(_auth.createToken);
}

/**
 * Removes visitor session and migrates the visitor account to the logged in user
 * @param {Object} attrs - Attributes
 * @param {number} [attrs.visitorToken] - visitors authentication token
 * @returns {promise} containing the visitor
 */
function remove(attrs) {
  return _apiClient2.default.remove({ route: API.VISITOR, params: attrs });
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@quiqupltd/quiqupjs/lib/visitor/visitor.js
// module id = 1190
// module chunks = 0